export default __webpack_public_path__ + "static/media/endorsement-fast.7fd11dcb.png";